import { render } from "./myWorks.vue?vue&type=template&id=6e9a5fd2&scoped=true"
import script from "./myWorks.vue?vue&type=script&lang=js"
export * from "./myWorks.vue?vue&type=script&lang=js"

import "./myWorks.vue?vue&type=style&index=0&id=6e9a5fd2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9a5fd2"]])

export default __exports__